export default from './stripIndents';
